export const SAVE_CRITERIA_SEARCH = 'SAVE_CRITERIA_SEARCH';
export const RESET_CRITERIA_MODULE_DATA = "RESET_CRITERIA_MODULE_DATA";